module.exports = __webpack_public_path__ + "16b52c87b1268caed64e66dfc1bf7041.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/server-product/images/jiaka_.png
// module id = 2471
// module chunks = 31